import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import MenuItem from '@mui/material/MenuItem'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import InputBase from '@mui/material/InputBase'
import SearchIcon from '@mui/icons-material/Search'
import Add from '@mui/icons-material/Add'
import Title from '../../component/Title'
import ResetFilterButton from '../../component/ResetFilterButton'
import { LIST_FILTER_SEARCH_FIELD_SX, LIST_FILTER_SEARCH_BUTTON_SX, ListFilterBar, ListFilterForm } from '../../component/ListFilterLayout'
import ListTableToolbar, { LIST_TABLE_TOOLBAR_BUTTON_SX } from '../../component/ListTableToolbar'
import ListTableContainer from '../../component/ListTableContainer'
import API from '../../component/Axios'
import Pagination from '../../component/Pagination'
import EditIcon from '../../component/EditIcon'
import DeleteAlertDialog from '../../component/DeleteAlertDialog'
import ListActionGroup from '../../component/ListActionGroup'
import ListEmptyState from '../../component/ListEmptyState'
import Snackbars from '../../component/Snackbars'
import Spiner from '../../component/Spiner'
import { buildListSearch as buildListSearchQuery, createInitialListState, createListLinkTarget, parseNumberParam } from '../../utils/listPageState'
import { renderDateTime } from '../../utils/dateDisplay'

const latlon = {
    '전체': [],
	'서울': ['강동구','송파구','강남구','서초구','관악구','동작구','영등포구','금천구','구로구','강서구','양천구','마포구','서대문구','은평구','노원구','도봉구','강북구','성북구','중랑구','동대문구','광진구','성동구','용산구','중구','종로구'],
	'강원': ['양양군','고성군','인제군','양구군','화천군','철원군','정선군','평창군','영월군','횡성군','홍천군','삼척시','속초시','태백시','동해시','강릉시','원주시','춘천시'],
	'경기': ['양평군','가평군','연천군','여주시','포천시','양주시','광주시','화성시','김포시','안성시','이천시','파주시','용인시','하남시','의왕시','군포시','시흥시','오산시','남양주시','구리시','과천시','고양시','안산시','동두천시','평택시','광명시','부천시','안양시','의정부시','성남시','수원시'],
	'경남': ['합천군','거창군','함양군','산청군','하동군','남해군','고성군','창녕군','함안군','의령군','양산시','거제시','밀양시','김해시','사천시','통영시','진주시','창원시'],
	'경북': ['울릉군','울진군','봉화군','예천군','칠곡군','성주군','고령군','청도군','영덕군','영양군','청송군','의성군','군위군','경산시','문경시','상주시','영천시','영주시','구미시','안동시','김천시','경주시','포항시'],
	'광주': ['광산구','북구','남구','서구','동구'],
	'대구': ['달성군','달서구','수성구','북구','남구','서구','동구','중구'],
	'대전': ['대덕구','유성구','서구','중구','동구'],
	'부산': ['기장군','사상구','수영구','연제구','강서구','금정구','사하구','해운대구','북구','남구','동래구','부산진구','영도구','동구','서구','중구'],
	'세종': ['어진동','다정동','나성동','가람동','반곡동','대평동','보람동','소담동','고운동','종촌동','아름동','도담동','새롬동','한솔동','소정면','전동면','전의면','연서면','장군면','금남면','부강면','연동면','연기면','조치원읍'],
	'울산': ['울주군','북구','동구','남구','중구'],
	'전남': ['신안군','진도군','완도군','장성군','영광군','함평군','무안군','영암군','해남군','강진군','장흥군','화순군','보성군','고흥군','구례군','곡성군','담양군','광양시','나주시','순천시','여수시','목포시'],
	'전북': ['부안군','고창군','순창군','임실군','장수군','무주군','진안군','완주군','김제시','남원시','정읍시','익산시','군산시','전주시'],
	'제주': ['서귀포시','제주시'],
	'충남': ['태안군','예산군','홍성군','청양군','서천군','부여군','금산군','당진시','계룡시','논산시','서산시','아산시','보령시','공주시','천안시'],
	'충북': ['단양군','음성군','괴산군','진천군','증평군','영동군','옥천군','보은군','제천시','충주시','청주시'],
	'인천': ['옹진군','강화군','서구','계양구','부평구','남동구','연수구','미추홀구','동구','중구']
}

const DEFAULT_SEARCH_SELECT = {
    searchType: 99,
    searchPrice: 99,
    searchCategory: '전체',
    searchCategory2: '',
}

const SEARCH_SELECT_PARAMS = {
    searchType: {
        param: 'type',
        defaultValue: DEFAULT_SEARCH_SELECT.searchType,
        parse: (value, defaultValue) => parseNumberParam(value, defaultValue),
    },
    searchPrice: {
        param: 'price',
        defaultValue: DEFAULT_SEARCH_SELECT.searchPrice,
        parse: (value, defaultValue) => parseNumberParam(value, defaultValue),
    },
    searchCategory: {
        param: 'sido',
        defaultValue: DEFAULT_SEARCH_SELECT.searchCategory,
    },
    searchCategory2: {
        param: 'sigu',
        defaultValue: DEFAULT_SEARCH_SELECT.searchCategory2,
    },
}

export default function Sports({ adminId, role }) {
    const location = useLocation()
    const history = useHistory()
    const initialListStateRef = useRef(createInitialListState({
        location,
        defaultSearchSelect: DEFAULT_SEARCH_SELECT,
        selectParams: SEARCH_SELECT_PARAMS,
    }))
    const initialListState = initialListStateRef.current
    const [loading, setLoading] = useState(true)
    const [actionLoading, setActionLoading] = useState(false)
    const [totalCount, setTotalCount] = useState(0)
    const [params, setParams] = useState([])
    const [curPage, setCurPage] = useState(initialListState.curPage)
    const offset = 10
    const [openSnackbar, setOpenSnackbar] = useState(initialListState.snackbar.openSnackbar)
    const [severitySnackbar, setSeveritySnackbar] = useState(initialListState.snackbar.severitySnackbar)
    const [messageSnackbar, setMessageSnackbar] = useState(initialListState.snackbar.messageSnackbar)
    const [searchText, setSearchText] = useState(initialListState.searchText)
    const [searchQuery, setSearchQuery] = useState(initialListState.searchQuery)
    const [searchSelect, setSearchSelect] = useState(initialListState.searchSelect)
    const [listErrorMessage, setListErrorMessage] = useState('')
    const deleteInFlightRef = useRef(false)
    const silentListRefreshRef = useRef(false)

    const getData = useCallback(async (showSpinner = true) => {
        if (showSpinner) {
            setLoading(true)
        }
        setListErrorMessage('')

        try {
            const { data } = await API.post('/api/v1/admin/sports/getList', {
                page: curPage, offset: offset, adminId: adminId, role: role, searchText: searchQuery, searchSelect: searchSelect
            })

            if (data.code === 200) {
                setTotalCount(data.data.count?.length || 0)
                setParams(data.data.rows || [])
                setListErrorMessage('')
            } else if (data.code === 403) {
                history.push('/login')
                return
            } else {
                const errorMessage = data.message || '운동시설 목록을 불러오지 못했습니다.'
                setTotalCount(0)
                setParams([])
                setListErrorMessage(errorMessage)
                setOpenSnackbar(true)
                setSeveritySnackbar('error')
                setMessageSnackbar(errorMessage)
            }
        } catch (_error) {
            const errorMessage = '운동시설 목록을 불러오지 못했습니다.'
            setTotalCount(0)
            setParams([])
            setListErrorMessage(errorMessage)
            setOpenSnackbar(true)
            setSeveritySnackbar('error')
            setMessageSnackbar(errorMessage)
        } finally {
            setLoading(false)
        }
    }, [adminId, curPage, history, role, searchQuery, searchSelect])

    useEffect(() => {
        const showSpinner = !silentListRefreshRef.current
        silentListRefreshRef.current = false
        getData(showSpinner)
    }, [getData])

    useEffect(() => {
        const nextSearch = buildListSearchQuery({
            curPage,
            searchQuery,
            searchSelect,
            selectParams: SEARCH_SELECT_PARAMS,
        })

        if (location.search !== nextSearch) {
            history.replace({
                pathname: location.pathname,
                search: nextSearch,
            })
        }
    }, [curPage, history, location.pathname, location.search, searchQuery, searchSelect])

    const handleClose = () => {
        setOpenSnackbar(false)
    }

    const hasActiveFilters = Boolean((searchQuery || '').trim())
        || String(searchSelect.searchType) !== String(DEFAULT_SEARCH_SELECT.searchType)
        || String(searchSelect.searchPrice) !== String(DEFAULT_SEARCH_SELECT.searchPrice)
        || String(searchSelect.searchCategory) !== String(DEFAULT_SEARCH_SELECT.searchCategory)
        || String(searchSelect.searchCategory2 || '') !== String(DEFAULT_SEARCH_SELECT.searchCategory2)

    const [sido] = useState(Object.keys(latlon))
    const [sigu, setSigu] = useState([])

    useEffect(() => {
        setSigu(latlon[searchSelect.searchCategory] || [])
    }, [searchSelect.searchCategory])

    const updateSearchSelect = (e) => {
        if (actionLoading) {
            return
        }

        if (curPage === 1) {
            silentListRefreshRef.current = true
        }

        if (e.target.name === 'searchCategory') {
            setSearchSelect({
                ...searchSelect,
                searchCategory: e.target.value,
                searchCategory2: ''
            })
        } else {
            setSearchSelect({
                ...searchSelect,
                [e.target.name]: e.target.value
            })
        }
        setSearchQuery((searchText || '').trim())
        setCurPage(1)
    }

    const handleSearchSubmit = (e) => {
        e.preventDefault()
        searchButtonClick()
    }

    const resetFilters = () => {
        if (actionLoading) {
            return
        }

        setCurPage(1)
        setSearchText('')
        setSearchQuery('')
        setSearchSelect({
            ...DEFAULT_SEARCH_SELECT,
        })
    }

    // 입력값과 실제 조회값을 분리해 Enter/검색 버튼 시점만 제어한다.
    const searchButtonClick = () => {
        if (actionLoading) {
            return
        }

        const trimmedSearchText = (searchText || '').trim()

        if (curPage === 1 && searchQuery === trimmedSearchText) {
            getData(false)
            return
        }

        setSearchQuery(trimmedSearchText)

        if (curPage !== 1) {
            setCurPage(1)
            return
        }

        if (searchQuery !== trimmedSearchText) {
            return
        }

        getData(false)
    }

    const handleSigu = (index) => {  
        setSigu(latlon[sido[index]])
    }

    // 운동시설 목록은 필터 종류가 많아 빈 결과와 조회 실패를 명확히 분리한다.
    const renderEmptyState = () => {
        if (listErrorMessage) {
            return (
                <ListEmptyState
                    variant="error"
                    title="운동시설 목록을 불러오지 못했습니다."
                    description={listErrorMessage}
                    action={(
                        <Button
                            type="button"
                            size="small"
                            variant="outlined"
                            onClick={() => getData(false)}
                            disabled={loading || actionLoading}
                        >
                            다시 조회
                        </Button>
                    )}
                />
            )
        }

        if (hasActiveFilters) {
            return (
                <ListEmptyState
                    title="조건에 맞는 운동시설이 없습니다."
                    description="타이틀, 지역, 요금타입, 가격정보 필터를 초기화한 뒤 다시 확인해보세요."
                    action={<ResetFilterButton label="필터 초기화" onClick={resetFilters} disabled={actionLoading} />}
                />
            )
        }

        return (
            <ListEmptyState
                title="조회된 운동시설이 없습니다."
                description="운동시설을 등록하면 이 목록에 표시됩니다."
            />
        )
    }

    const handleDelete = (id) => {
        if (deleteInFlightRef.current) {
            return
        }

        deleteInFlightRef.current = true
        setActionLoading(true)

        const deleteData = async () => {
            try {
                const { data } = await API.post('/api/v1/admin/sports/delete', { sportsId: id })

                if (data.code === 200) {
                    setOpenSnackbar(true)
                    setSeveritySnackbar('success')
                    setMessageSnackbar(data.message)

                    if (params.length === 1 && curPage > 1) {
                        setCurPage((prev) => prev - 1)
                        return
                    }

                    await getData(false)
                } else if (data.code === 403) {
                    history.push('/login')
                } else {
                    setOpenSnackbar(true)
                    setSeveritySnackbar('error')
                    setMessageSnackbar(data.message)
                }
            } catch (_error) {
                setOpenSnackbar(true)
                setSeveritySnackbar('error')
                setMessageSnackbar('운동시설을 삭제하지 못했습니다.')
            } finally {
                deleteInFlightRef.current = false
                setActionLoading(false)
            }
        }
        deleteData()
    }

    return (
        <Grid item xs={12}>
            {loading ? (
                <Grid item xs={12}>
                    <Spiner/>
                    {openSnackbar && <Snackbars open={openSnackbar} severity={severitySnackbar} message={messageSnackbar} handleClose={handleClose}/>}
                </Grid>
            ) : (
                <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', width: '100%' }}>
                    {/* 타이틀 */}
                    <Title>운동시설 리스트</Title>
                    {/* 검색폼 */}
                    <ListFilterBar>
                        <ListFilterForm onSubmit={handleSearchSubmit} trailing={<ResetFilterButton onClick={resetFilters} disabled={actionLoading} />}>
                            <InputBase
                                sx={LIST_FILTER_SEARCH_FIELD_SX}
                                placeholder="타이틀"
                                type="search" 
                                name="searchText"
                                value={searchText}
                                disabled={actionLoading}
                                onChange={(e) => setSearchText(e.target.value)}
                            />
                            <IconButton type="submit" sx={LIST_FILTER_SEARCH_BUTTON_SX} aria-label="search" disabled={actionLoading}><SearchIcon /></IconButton>
                            <Divider sx={{ height: 28, m: 0.5, marginRight:2 }} orientation="vertical" />
                            {/* <TextField
                                label="카테고리"
                                select
                                name="searchCategory"
                                value={searchSelect.searchCategory}
                                onChange={updateSearchSelect}
                                size="small"
                                disabled={actionLoading}
                                sx={{ minWidth: 150 }}
                            >
                                <MenuItem value={0}>전체</MenuItem>
                                <MenuItem value={1}>헬스</MenuItem>
                            </TextField> */}
                            <TextField
                                label="시도"
                                select
                                name="searchCategory"
                                value={searchSelect.searchCategory}
                                onChange={updateSearchSelect}
                                size="small"
                                disabled={actionLoading}
                                sx={{ minWidth: 150 }}
                            >
                                {sido.map((row, index) => (
                                    <MenuItem key={index} value={row} onClick={() => handleSigu(index)}>{row}</MenuItem>
                                ))}
                            </TextField>
                            <TextField
                                label="시구"
                                select
                                name="searchCategory2"
                                value={searchSelect.searchCategory2 || ''}
                                onChange={updateSearchSelect}
                                size="small"
                                disabled={actionLoading || searchSelect.searchCategory === '전체'}
                                sx={{ minWidth: 150 }}
                            >
                                {/* <MenuItem value={''}></MenuItem> */}
                                {sigu.map((row, index) => (
                                    <MenuItem key={index} value={row}>{row}</MenuItem>
                                ))}
                            </TextField>
                            <TextField
                                label="요금타입"
                                select
                                name="searchType"
                                value={searchSelect.searchType}
                                onChange={updateSearchSelect}
                                size="small"
                                disabled={actionLoading}
                                sx={{ minWidth: 150 }}
                            >
                                <MenuItem value={99}>전체</MenuItem>
                                <MenuItem value={4}>요금제(상)</MenuItem>
                                <MenuItem value={3}>요금제(중)</MenuItem>
                                <MenuItem value={2}>요금제(하)</MenuItem>
                                <MenuItem value={1}>무료</MenuItem>
                            </TextField>
                            <TextField
                                label="가격정보"
                                select
                                name="searchPrice"
                                value={searchSelect.searchPrice}
                                onChange={updateSearchSelect}
                                size="small"
                                disabled={actionLoading}
                                sx={{ minWidth: 150 }}
                            >
                                <MenuItem value={99}>전체</MenuItem>
                                <MenuItem value={1}>있음</MenuItem>
                                <MenuItem value={0}>없음</MenuItem>
                            </TextField>
                        </ListFilterForm>

                    </ListFilterBar>
                    
                    {/* 테이블 */}
                    <ListTableToolbar
                        right={(
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<Add />}
                                size="small"
                                disabled={actionLoading}
                                sx={LIST_TABLE_TOOLBAR_BUTTON_SX}
                                onClick={() => history.push(createListLinkTarget({
                                    pathname: '/new-sport',
                                    search: location.search,
                                    curPage: curPage,
                                    searchText: searchQuery,
                                    searchSelect: searchSelect
                                }))}
                            >
                                등록
                            </Button>
                        )}
                    />
                    <ListTableContainer>
                    <Table size="small" sx={{ minWidth: 1200 }}>
                        <caption>Total Count: {totalCount}</caption>
                        <TableHead>
                            <TableRow>
                                <TableCell>No</TableCell>
                                <TableCell>이미지</TableCell>
                                <TableCell>요금타입</TableCell>
                                <TableCell>가격정보</TableCell>
                                <TableCell>타이틀</TableCell>
                                <TableCell align="left">주소<br/>연락처</TableCell>
                                <TableCell align="left">메모</TableCell>
                                {/* <TableCell>운영시간</TableCell>
                                <TableCell align="center">가격안내</TableCell> */}
                                <TableCell>등록일</TableCell>
                                <TableCell align="right">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {params.length > 0 ? (
                                params.map((row) => (
                                    <TableRow key={row.sportsId}>
                                        <TableCell>{row.rownum}</TableCell>
                                        <TableCell><img className="listImg" src={`${process.env.REACT_APP_AWS_S3_URL}/${row.thumbnail}`} alt="" /></TableCell>
                                        <TableCell>{row.type === 1 ? '무료' : row.type === 2 ? '요금제(하)' : row.type === 3 ? '요금제(중)' : '요금제(상)'}</TableCell>
                                        <TableCell>{row.price.trim().length ? 'O' : 'X'}</TableCell>
                                        <TableCell>{row.title}</TableCell>
                                        <TableCell align="left" className="listTableLimitText">
                                            {row.address2}<br/>{row.phone}
                                        </TableCell>
                                        <TableCell align="left" className="listTableLimitText">{row.memo}</TableCell>
                                        {/* <TableCell style={{ whiteSpace: 'pre-wrap' }} >{row.openingHours}</TableCell>
                                        <TableCell align="center">{PriceTd(row.price)}</TableCell> */}
                                        <TableCell>{renderDateTime(row.regTime)}</TableCell>
                                        <TableCell align="right">
                                            <ListActionGroup disabled={actionLoading}>
                                                <EditIcon path={'sport'} id={row.sportsId} search={location.search} curPage={curPage} searchText={searchQuery} searchSelect={searchSelect} />
                                                <DeleteAlertDialog handleDelete={handleDelete} id={row.sportsId}/>
                                            </ListActionGroup>
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={9}>
                                        {renderEmptyState()}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    </ListTableContainer>
                    {totalCount > 0 && <Pagination curPage={curPage} offset={offset} totalCount={totalCount} setCurPage={setCurPage} />}
                    {openSnackbar && <Snackbars open={openSnackbar} severity={severitySnackbar} message={messageSnackbar} handleClose={handleClose}/>}
                </Paper>
            )}
        </Grid>
    )
}
